import { InAppMessageActionViewEvent, InAppMessageViewEvent } from "./InAppMessageViewEvent"
import { InAppMessageView } from "../view/InAppMessageView"

import { InAppMessageViewEventHandleType } from "./InAppMessageViewEventHandleType"
import { InAppMessageEventTracker } from "./InAppMessageEventTracker"
import { InAppMessageViewEventActorFactory } from "./InAppMessageViewEventActor"

export interface InAppMessageViewEventHandler {
  supports(handleType: InAppMessageViewEventHandleType): boolean

  handle(view: InAppMessageView, event: InAppMessageViewEvent): void
}

export class InAppMessageViewEventHandlerFactory {
  constructor(private readonly handlers: InAppMessageViewEventHandler[]) {}

  get(handleType: InAppMessageViewEventHandleType): InAppMessageViewEventHandler | undefined {
    return this.handlers.find((it) => it.supports(handleType))
  }
}

export class InAppMessageViewEventTrackHandler implements InAppMessageViewEventHandler {
  constructor(private readonly eventTracker: InAppMessageEventTracker) {}
  handle(view: InAppMessageView, event: InAppMessageViewEvent): void {
    this.eventTracker.track(view.context, event)
  }

  supports(handleType: InAppMessageViewEventHandleType): boolean {
    return handleType === "TRACK"
  }
}

export class InAppMessageViewEventActionHandler implements InAppMessageViewEventHandler {
  constructor(private readonly viewEventActorFactory: InAppMessageViewEventActorFactory) {}

  handle(view: InAppMessageView, event: InAppMessageActionViewEvent): void {
    const actor = this.viewEventActorFactory.get(event)
    actor?.action(view, event)
  }

  supports(handleType: InAppMessageViewEventHandleType): boolean {
    return handleType === "ACTION"
  }
}
